<template>
  <!-- <div class="p-4" style="background-color: #5e8dad; margin-top: 1vh;">
    <h1>Race Planner</h1>
  </div> -->
  <div>
    <div class="pt-3 pl-3 pb-2 mb-3" style="background-color: var(--bootstrapgrey); border-bottom-left-radius: 0px; border-top-left-radius: 0px;">
      <h3 class="section-title" style="text-transform: uppercase; font-weight: 400; color: #000;">Race Planner</h3>
    </div>

    <div class="ml-2">

      <form action="" style="max-width: 500px;" class="">
        <div class="row form-row">
          <div class="col-sm-5 col-lg-12">
            <label for="raceType">What distance is the race?</label>
            <select class="form-control" id="raceType" v-model="raceType">
              <option>5k</option>
              <option>10k</option>
              <option>Half Marathon</option>
              <option>Marathon</option>
              <option>Custom</option>
            </select>
          </div>
        </div>

        <div class="form-row mt-2" v-if="raceType == 'Custom'">
          <div class="form-group col-lg-10 col-md-10">
            <!-- <label for="raceDistance">Distance</label> -->
            <input type="text" class="form-control" id="raceDistance" placeholder="Distance" v-model="customDistance">
            <!-- <small v-if="$v.raceName.$invalid && saveClicked">A race name is required.</small> -->
          </div>
          <div class="form-group col-lg-2 col-md-2" style="max-width: 100px;">
            <select class="form-control" id="" v-model="distanceUnits">
              <option>km</option>
              <option>mi</option>
            </select>
          </div>
        </div>

        <div class="form-row mt-2">
          <div class="col-lg-12">
            <div class="">
              <label for="raceType">What do you know?</label>
            </div>
            <div style="line-height: 1.2" class="check-box">
              <input type="radio" id="PBcheckbox" v-model="known" value="pace">
              <label for="PBcheckbox" class="ml-2 mt-1">Pace</label>
              <!-- <input type="checkbox" id="PBcheckbox" v-model="paceCheck" class="ml-2">
              <label for="PBcheckbox" class="ml-1 mt-1">Pace</label> -->
            </div>
            <div style="line-height: 1.2" class="check-box">
              <!-- <input type="checkbox" id="PBcheckbox" v-model="paceCheck">
              <label for="PBcheckbox" class="ml-1 mt-1">Pace</label> -->
              <input type="radio" id="PBcheckbox" v-model="known" class="" value="finishingtime">
              <label for="PBcheckbox" class="ml-2 mt-1">Finishing Time</label>
            </div>
          </div>
        </div>

        <div class="mt-2" v-if="known == 'finishingtime'">
          <label for="">Finishing Time</label>
          <!-- <div class="form-row">
            <div class="col-lg-4 col-md-4 col-sm-4 input-group" style="padding-right: 0;">
              <input type="number" class="form-control" id="" placeholder="hours" v-model="hours" style="border-top-right-radius: 0; border-bottom-right-radius: 0;">
              <div class="input-group-append">
                <span class="input-group-text" id="basic-addon1" style="border-top-right-radius: 0; border-bottom-right-radius: 0; border-right-width: 0;">:</span>
              </div>
            </div>
            <div class="col-lg-4 col-md-4 input-group" style="padding-left: 0; padding-right: 0;">
              <input type="number" class="form-control" id="" placeholder="mins" v-model="minutes" style="border-top-left-radius: 0; border-bottom-left-radius: 0;">
              <div class="input-group-append">
                <span class="input-group-text" id="basic-addon1" style="border-top-right-radius: 0; border-bottom-right-radius: 0; border-right-width: 0;">:</span>
              </div>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-4" style="padding-left: 0; padding-right: 30px;">
              <input type="number" class="form-control" id="" placeholder="secs" v-model="seconds" style="border-top-left-radius: 0; border-bottom-left-radius: 0;">
            </div>
          </div> -->
          <div class="input-group">
            <input type="number" class="form-control" id="" placeholder="hours" v-model="hours" style="border-top-right-radius: 0; border-bottom-right-radius: 0;">
            <div class="input-group-append">
              <span class="input-group-text" id="basic-addon1" style="border-top-right-radius: 0; border-bottom-right-radius: 0; border-right-width: 0;">:</span>
            </div>
            <input type="number" class="form-control" id="" placeholder="mins" v-model="minutes" style="border-top-left-radius: 0; border-bottom-left-radius: 0;">
            <div class="input-group-append">
              <span class="input-group-text" id="basic-addon1" style="border-top-right-radius: 0; border-bottom-right-radius: 0; border-right-width: 0;">:</span>
            </div>
            <input type="number" class="form-control" id="" placeholder="secs" v-model="seconds" style="border-top-left-radius: 0; border-bottom-left-radius: 0;">
          </div>
        </div>

        <div class="mt-2" v-if="known == 'pace'">
          <label for="">Average Pace</label>
          <div class="row">
            <div class="col-lg-8">
              <!-- <div class="form-row">
                <div class="col-lg-6 input-group" style="padding-left: ; padding-right: 0;">
                  <input type="number" class="form-control" id="" placeholder="mins" v-model="paceMinutes" style="border-top-left-radius: ; border-bottom-left-radius: ;">
                  <div class="input-group-append">
                    <span class="input-group-text" id="basic-addon1" style="border-top-right-radius: 0; border-bottom-right-radius: 0; border-right-width: 0;">:</span>
                  </div>
                </div>
                <div class="col-lg-6" style="padding-left: 0; padding-right: 25px;">
                  <input type="number" class="form-control" id="" placeholder="secs" v-model="paceSeconds" style="border-top-left-radius: 0; border-bottom-left-radius: 0;">
                </div>
              </div> -->
              <div class="input-group mb-1">
                <input type="number" class="form-control" id="" placeholder="mins" v-model="paceMinutes" style="border-top-left-radius: ; border-bottom-left-radius: ;">
                <div class="input-group-append">
                  <span class="input-group-text" id="basic-addon1" style="border-top-right-radius: 0; border-bottom-right-radius: 0; border-right-width: 0;">:</span>
                </div>
                <input type="number" class="form-control" id="" placeholder="secs" v-model="paceSeconds" style="border-top-left-radius: 0; border-bottom-left-radius: 0;">
              </div>
            </div>
            <div class="col-lg-4">
              <div class="form-group" style="">
                <select class="form-control" id="" v-model="paceUnits">
                  <option>per km</option>
                  <option>per mile</option>
                </select>
              </div>
            </div>
          </div>

        </div>
      </form>
      <hr>

      <div class="" v-if="known == 'finishingtime'">
        <h5>Your average race pace is <span v-if="racePace">{{ projectedPaceMinutesKm }}:{{ projectedPaceSecondsKm | twoDigits }} per km, {{ projectedPaceMinutesMi }}:{{ projectedPaceSecondsMi | twoDigits }} per mile</span></h5>
      </div>

      <div v-if="known == 'pace'">
        <h5>Your projected finishing time is <span v-if="finishingTime">{{ projectedHours }}:{{ projectedMinutes }}:{{ projectedSeconds | twoDigits }}</span></h5>
      </div>

      <hr>

      <h5 class="mt-5" style="color: gray;">Pace bands coming soon!</h5>

    </div>

    <!-- {{ raceDistance }} -->
    <!-- {{ raceType }} -->
    <!-- {{ racePace }} -->
    <!-- {{ customDistance }} -->

  </div>
</template>

<script>
  export default {
    data () {
      return {
        raceType: '',
        customDistance: null,
        distanceUnits: 'km',
        // paceCheck: false,
        // timeCheck: true,
        known: 'finishingtime',
        hours: null,
        minutes: null,
        seconds: null,
        paceMinutes: null,
        paceSeconds: null,
        paceUnits: 'per km',
        projectedHours: null,
        projectedMinutes: null,
        projectedSeconds: null,
        projectedPaceMinutesKm: null,
        projectedPaceSecondsKm: null,
        projectedPaceMinutesMi: null,
        projectedPaceSecondsMi: null,
      }
    },
    computed: {
      raceDistance () {
        if (this.raceType == '5k') {
          return 5000
        }
        else if (this.raceType == '10k') {
          return 10000
        }
        else if (this.raceType == 'Half Marathon') {
          return 21100
        }
        else if (this.raceType == 'Marathon') {
          return 42200
        }
        else if (this.raceType == 'Custom') {
          if (this.distanceUnits == 'km') {
            return this.customDistance * 1000
          }
          if (this.distanceUnits == 'mi') {
            return this.customDistance * 1609
          }
        }
        else {
          return 0
        }
        // console.log('computing')
      },
      finishingTime () {
        if ((this.raceDistance != 0) && (this.known = 'pace') && this.paceMinutes) {
          let paceSecs = null
          // if (this.paceUnits == 'per km') {
            if (this.paceMinutes) {
              paceSecs += this.paceMinutes * 60
            }
            if (this.paceSeconds) {
              paceSecs += this.paceSeconds * 1 // convert string to a number
            }
          // }

          // If user entered pace in km, we want race distance in km, and if in miles than race distance also in miles
          let unitaryDistance = null
          if (this.paceUnits == 'per km') {
            unitaryDistance = this.raceDistance / 1000
          }
          if (this.paceUnits == 'per mile') {
            unitaryDistance = this.raceDistance / 1609
          }

          // multiple the pace in seconds (PER KM OR MILE) by the total distance (in miles or km, not meters)
          console.log(paceSecs)
          // let totalSecs = this.raceDistance * paceSecs
          let totalSecs = unitaryDistance * paceSecs
          console.log(totalSecs)

          this.projectedHours = Math.floor(totalSecs / 3600)
          console.log(this.projectedHours)
          this.projectedMinutes = Math.floor((totalSecs - this.projectedHours * 3600) / 60)
          console.log(this.projectedMinutes)
          this.projectedSeconds = totalSecs - this.projectedHours * 3600 - this.projectedMinutes * 60
          console.log(this.projectedSeconds)

          return 1
        }
        else {
          return null
        }
      },
      racePace () {
        if ((this.raceDistance != 0) && (this.known = 'finishingtime') && (this.hours || this.minutes)) {
          // return 1
          // return this.raceDistance
          let distanceKm = this.raceDistance / 1000
          console.log(distanceKm)
          let distanceMi = this.raceDistance / 1609
          console.log(distanceMi)
          // let finishingtimeMins = parseInt(this.hours) * 60 + parseInt(this.minutes) + parseInt(this.seconds)/60
          let finishingtimeMins = 0
          let finishingTimeSecs = 0
          if (this.hours) {
            finishingtimeMins += parseInt(this.hours) * 60
            finishingTimeSecs += parseInt(this.hours) * 3600
          }
          if (this.minutes) {
            finishingtimeMins += parseInt(this.minutes)
            finishingTimeSecs += parseInt(this.minutes) * 60
          }
          if (this.seconds) {
            finishingtimeMins += parseInt(this.seconds) / 60
            finishingTimeSecs += parseInt(this.seconds)
          }
          // console.log(finishingtimeMins)
          console.log(finishingTimeSecs)
          this.projectedPaceMinutesKm = Math.floor(finishingtimeMins / distanceKm)
          this.projectedPaceMinutesKm = Math.floor(finishingTimeSecs / distanceKm / 60)
          // this.projectedPaceSecondsKm = finishingtimeMins / distanceKm
          this.projectedPaceSecondsKm = (finishingTimeSecs - this.projectedPaceMinutesKm * distanceKm * 60) / distanceKm
          // if (this.seconds) {
          //   this.projectedPaceSecondsKm = this.seconds / distanceKm
          // } else {
          //   this.projectedPaceSecondsKm = 0
          // }
          this.projectedPaceMinutesMi = Math.floor(finishingtimeMins / distanceMi)
          this.projectedPaceMinutesMi = Math.floor(finishingTimeSecs / distanceMi /60)
          // this.projectedPaceSecondsMi = finishingtimeMins / distanceMi
          // if (this.seconds) {
          //   this.projectedPaceSecondsMi = this.seconds / distanceKm
          // } else {
          //   this.projectedPaceSecondsMi = 0
          // }
          this.projectedPaceSecondsMi = (finishingTimeSecs - this.projectedPaceMinutesMi * distanceMi * 60) / distanceMi
          return 1
        }
        else {
          return null
        }
      }
    },
    methods: {
      calculateDistance () {
        if (this.raceType == '5k') {
          return 5000
        }
        else {
          return 0
        }
      },
    }
  }
</script>

<style>
  .check-box {
    display: -webkit-box;
    display: flex;
    -webkit-box-align: center;
    align-items: center;
    /* margin-top: 5px; */
  }
</style>



// WEBPACK FOOTER //
// src/components/myrundash/RacePlanner.vue